import CardProductAdmin from './CardProductAdmin';

export default CardProductAdmin;